import { connect, ConnectedProps } from 'react-redux';
import { selectIsDataFromTriumph } from 'src/store/selectors';
import { RootState } from '../../../../reducers';
import { selectAfsls } from '../../common/store/selectors';
import { Filters } from './components/filters';
import { selectModels, selectParameters, selectSecurities } from './store/selectors';
import { searchSlice } from './store/slice';
import { fetchModels, fetchResults, fetchSecurities } from './store/thunks';

const mapStateToProps = (state: RootState) => ({
  afsls: selectAfsls(state),
  securities: selectSecurities(state),
  models: selectModels(state),
  parameters: selectParameters(state),
  isDataFromTriumph: selectIsDataFromTriumph(state),
  isLoading: false,
  hasErrors: false,
});

const mapDispatchToProps = {
  ...searchSlice.actions,
  fetchResults,
  fetchSecurities,
  fetchModels,
};

const connector = connect(mapStateToProps, mapDispatchToProps);
export type Props = ConnectedProps<typeof connector>;
export const ReportSearchFiltersContainer = connector(Filters);
